/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: theme.routes.cartUrl + '/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  if (navigator.onLine) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      alert(data.message + '(' + data.status  + '): ' + data.description);
    }
  } else {

  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $form = $(form);
  var formData;

  // Check if we have a license variant
  if($form.closest(".js-product-single-actions").find(".product-form__swatch-for-licence").length) {
    var tempFormData = new FormData(form);
    var licenceId = tempFormData.get("licence-id");
    var productId = tempFormData.get("id");
    var quantity = tempFormData.get("quantity");
    
    console.log("Adding product with license:", {
      licenceId: licenceId,
      productId: productId,
      quantity: quantity
    });

    // If we have a license quantity field
    if($form.closest(".js-product-single-actions").find("[name='licence-quantity']").length) {
      var licenceQuantity = tempFormData.get("licence-quantity");
      console.log("License quantity specified:", licenceQuantity);
      
      formData = {
                'items': [
                {
            'id': licenceId,
            'quantity': licenceQuantity,
            'properties': {
                    '_Licence for': "Licence for product"
                 }
                },
                {
            'id': productId,
            'quantity': quantity,
            'properties': {   
              'Doors Connected': licenceQuantity
                 }
                }           
                ]
            };
    } else {
      // Get license name if available
      var licenceName = $form.find("[name='licence-id'] option:selected").text() || "Standard License";
      console.log("License name:", licenceName);
      
      formData = {
                'items': [
                {
            'id': licenceId,
            'quantity': quantity,
            'properties': { 
                    '_Licence for': "Licence for product"
                 }
                },
                {
            'id': productId,
            'quantity': quantity,
            'properties': {   
                  '_License': licenceName,
              '_Licence_ID': licenceId
                 }
                }
                ]
            };
        }
  } else {
    // Regular product without license
    console.log("Adding regular product without license");
    formData = $form.serialize();
  }

  console.log("Final form data:", formData);
  
  var $body = $(document.body);
  var params = {
    type: 'POST',
    url: theme.routes.cartAddUrl + '.js',
    data: formData,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      console.log("Successfully added to cart:", line_item);
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      console.error("Error adding to cart:", {
        status: XMLHttpRequest.status,
        statusText: XMLHttpRequest.statusText,
        responseText: XMLHttpRequest.responseText
      });
      if (errorCallback && (typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus, form);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON(theme.routes.cartUrl + '.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, errorCallback) {

var $row = $('.ajaxcart__row[data-line="' + line + '"]');
if($row.attr("data-licence-value") != "" && $row.attr("data-licence-value") != null){
  var variantID = $row.attr("data-variant-id");
  var licenceValue = $row.attr("data-licence-value");
  var licenceValue2 = $row.attr("data-licence-value-2");
  

  var $licenceRow = $('.ajaxcart__row[data-variant-id="' + licenceValue + '"][data-licence-id="Licence for product"]');
  if($licenceRow.length){
    var licenceKey = $licenceRow.attr("data-key");
    var itemKey = $row.attr("data-key");
    var requestUrl = theme.routes.cartUpdateUrl + '.js';
    var itemOriginalQTY = $row.attr("data-original-qty")*1;
    var licenceOriginalQTY = $licenceRow.attr("data-original-qty")*1;
    var licenceQuantity = licenceOriginalQTY + (quantity*1 - itemOriginalQTY);

      var $licenceRow2 = $('.ajaxcart__row[data-variant-id="' + licenceValue2 + '"][data-licence-id="Licence for product"]');
      if($licenceRow2.length){
           var licenceKey2 = $licenceRow2.attr("data-key");
           var data = 'updates['+itemKey+']='+quantity+'&updates['+licenceKey+']='+licenceQuantity+'&updates['+licenceKey2+']='+licenceQuantity;
           $licenceRow.addClass('is-loading');      
           $licenceRow2.addClass('is-loading');       
       }else{
          var data = 'updates['+itemKey+']='+quantity+'&updates['+licenceKey+']='+licenceQuantity;
          $licenceRow.addClass('is-loading');       
       }  
  }
  
}else{
  var requestUrl = theme.routes.cartChangeUrl + '.js';
  var data = 'quantity=' + quantity + '&line=' + line;
} 

  //debugger;

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: requestUrl,
    data: data,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, initForm, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $emptySelector, $triggerSelector;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, adjustCartErrorCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      sourceId           : '#CartTemplate',
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      triggerSelector    : null,
      emptySelector      : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $emptySelector     = $(settings.emptySelector);
    $triggerSelector   = $(settings.triggerSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Enable hidden id field
    $formContainer.find('[name="id"]').removeAttr('disabled');

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  initForm = function(form) {
    if (!form) return;

    const $form = $(form);
    const $thisAddToCart = $form.find(settings.addToCartSelector);

    // Enable hidden id field
    $form.find('[name="id"]').removeAttr('disabled');

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors(form);
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $thisAddToCart.length) {
      formOverride(form);
    }
  }

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function (form) {
    const submitCallback = (evt) => {
      evt.preventDefault();

      var thisAddToCart = $(evt.target).find(settings.addToCartSelector);
      // Add class to be styled if desired
      thisAddToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    }

    if (form) {
      const $form = $(form);
      $form.find('[name="id"]').removeAttr('disabled');

      $(form).on('submit', submitCallback);
    } else {
      $formContainer.on('submit', submitCallback);
    }
  };

  //setting up current product data variable
  var thisProduct = {};
  itemAddedCallback = function (product, form) {
    var $body = $(document.body);
    var thisAddToCart = $(form).find(settings.addToCartSelector);

    // Add class to be styled if desired
    thisAddToCart.removeClass('is-adding').addClass('is-added');

    // removes button styling when animation finishes
    form.querySelector(".js-product-add.is-added").addEventListener("animationend", function() {
      const quickShopElement = form.closest("quick-shop");
      const addedFromCard = !!form.closest(".product-card");

      thisAddToCart.removeClass('is-added');
      $body.trigger('afterButtonAnimation.ajaxCart', [quickShopElement, addedFromCard]);
    }, { once: true });

    // removes button styling if mouse leaves quick shop card
    if(form.classList.contains('product-form--card') && form.closest(".product-card--trigger-icon")){
      form.closest(".product-card--trigger-icon").addEventListener("mouseleave", function(){
        thisAddToCart.removeClass('is-added');
      }, { once: true });
    }

    // removes button styling if mouse leaves quick shop drawer
    if(form.classList.contains('product-form--card') && form.closest(".mfp-content")){
      form.closest("quick-shop").addEventListener("closed.quickShop", function(){
        thisAddToCart.removeClass('is-added');
      }, { once: true });
    }

    thisProduct = product;

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, form) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (data && !!data.message) {
      if (data.status == 422) {
        $(form).after('<div class="errors qty-error u-small">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $emptySelector.show();
      $emptySelector.attr("aria-hidden", "false");
      $cartContainer.hide();
      $('.js-cart-trigger').removeClass('js-cart-full');
    } else {
      $emptySelector.hide();
      $emptySelector.attr("aria-hidden", "true");
      $cartContainer.show();
      $('.js-cart-trigger').addClass('js-cart-full');

      // Get and compile the cart template
      const source = $('#CartTemplate').html();
      const template = Handlebars.compile(source);

      // Add each item to our handlebars.js data
      const items = cart.items.map((cartItem, index) => {
        return {
          key: cartItem.key,
          line: index + 1,
          url: cartItem.url,
          img: cartItem.image ? cartItem.image.replace(/(\.[^.]*)$/, "_240x$1").replace('http:', '') : null,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: Shopify.formatMoney(cartItem.price, theme.moneyFormat),
          vendor: cartItem.vendor,
          linePrice: Shopify.formatMoney(cartItem.final_line_price, theme.moneyFormat),
          originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, theme.moneyFormat),
          discounts: cartItem.discounts,
          discountPrice: Shopify.formatMoney(cartItem.final_line_price, theme.moneyFormat)
        };
      });

      // Gather all cart data and add to DOM
      const data = {
        items: items,
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, theme.moneyFormat),
        totalCartDiscount: cart.total_discount === 0 ? 0 : Shopify.formatMoney(cart.total_discount, theme.moneyFormat),
        totalCartDiscountApplied: cart.total_discount === 0 ? false : true
      };

      $cartContainer.append(template(data));
    }

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove from the quantity
    $body.on('click', '.ajaxcart__remove', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line');

      $el.attr('disabled', 'disabled');

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, 0);
      } else {
        $qtySelector.val(0);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback, adjustCartErrorCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    $cartContainer.find('.errors').remove();

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  adjustCartErrorCallback = function(XMLHttpRequest, textStatus) {
    const data = eval('(' + XMLHttpRequest.responseText + ')');
    const form = $cartContainer.find('form');

    if (data && !!data.message) {
      if (data.status == 422) {
        form.before(`<div class="errors qty-error u-small">${data.description}</div>`);
      }
    } else {
      const message = textStatus === 'error' && !navigator.onLine ? 'No internet connection' : textStatus;
      form.before(`<div class="errors u-small">${message}</div>`);
    }

    isUpdating = false;
    $cartContainer.find('.is-removed').removeClass('is-removed');
    $cartContainer.find('.is-loading').removeClass('is-loading');
    $cartContainer.find('.ajaxcart__remove').attr('disabled', false);
  }

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"].js-qty-input', $cartContainer).length) {
      $('input[type="number"].js-qty-input', $cartContainer).each(function() {

        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function(form) {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    const setUpNumInputs = (el) => {
      if (!el.parentElement.classList.contains('js-qty')) {
        var $el = $(el),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id'),
            formId = $el.attr('form');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              formId: formId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();      
      }
    }

    const numberAdjust = (e) => {
      var $el = $(e.target),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));
      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 1) qty = 1;
      }

      // Update the input's number
      $qtySelector.val(qty).change();
    }


    if (form) {
      const numInputs = form.querySelector('input[type="number"].js-qty-input') || document.querySelector(`input[type="number"][form="${form.getAttribute('id')}"].js-qty-input`);

      if (numInputs) {
        setUpNumInputs(numInputs);
      }

      const qtyAdjustButtons = $(form).find('.js-qty__adjust').length > 0 ?
        $(form).find('.js-qty__adjust') :
        $(`input[type="number"][form="${form.getAttribute('id')}"].js-qty-input`).parent().find('.js-qty__adjust');

      const newNumInputs = document.querySelectorAll('.js-qty-input-cart input[type="number"].js-qty-input');
       Array.from(newNumInputs).forEach((inputEl) => {
          $(inputEl).on("change",function(){
            var cardWrapper = $(this).closest(".cart__product");
            var currentValue = $(this).val()*1;
            var qtyWrapper = $(this).closest("[data-product-licence-id]");           
            if(qtyWrapper.length){
              var licenceID = qtyWrapper.attr("data-product-licence-id");
              if(licenceID != "" && licenceID != null){
                var originalQTY = qtyWrapper.attr("data-original-qty") * 1;
                var nextInput = $(".cart__products").find(".visually-hidden-qty[data-variant-id="+licenceID+"] .js-qty__num");
                if(nextInput){
                  nextInput.val(nextInput.val()*1 + (currentValue - originalQTY)); 
                  qtyWrapper.attr("data-original-qty",currentValue);
                 }
              }
            }
          });
        });
      
      $(qtyAdjustButtons).on('click', numberAdjust);
       
      
    } else {
      const numInputs = document.querySelectorAll('input[type="number"].js-qty-input');

      Array.from(numInputs).forEach((el) => setUpNumInputs(el));

      const newNumInputs = document.querySelectorAll('.js-qty-input-cart input[type="number"].js-qty-input');
       Array.from(newNumInputs).forEach((inputEl) => {
          $(inputEl).on("change",function(){
            var cardWrapper = $(this).closest(".cart__product");
            var currentValue = $(this).val()*1;
            var qtyWrapper = $(this).closest("[data-product-licence-id]");           
            if(qtyWrapper.length){
              var licenceID = qtyWrapper.attr("data-product-licence-id");
              if(licenceID != "" && licenceID != null){
                var originalQTY = qtyWrapper.attr("data-original-qty") * 1;
                var nextInput = $(".cart__products").find(".visually-hidden-qty[data-variant-id="+licenceID+"] .js-qty__num");
                if(nextInput){
                  nextInput.val(nextInput.val()*1 + (currentValue - originalQTY)); 
                  qtyWrapper.attr("data-original-qty",currentValue);
                 }
              }
            }
          });
        });


      const doorsNumInputs = document.querySelectorAll('.doors-quantity-selector .js-qty-input');
       Array.from(doorsNumInputs).forEach((inputEl) => {
         var qtyWrapper = $(inputEl).closest(".product-single__box__block--quantity_selector");
         var qtyInput = qtyWrapper.find("[name='quantity']");
         
          $(inputEl).on("change",function(){
            var qtyWrapper = $(this).closest(".product-single__box__block--quantity_selector");
            var qtyInput = qtyWrapper.find("[name='quantity']");
            var currentValue = $(this).val()*1;
            var maxDoorsAmount = $(this).closest('.doors-quantity-selector').attr("data-doors-amount")*1;
                                
            if(qtyInput.length){             
              var neededValue = Math.ceil(currentValue / maxDoorsAmount) * maxDoorsAmount;
              qtyInput.val(neededValue/maxDoorsAmount).trigger("change");
            }
          });

           if(qtyInput.length){     
              $(qtyInput).on("change",function(){
             var licenceInput = $(this).closest(".js-product-single-actions").find(".product-form__swatch-for-licence input:checked");
              if(licenceInput.length){
                licenceInput.trigger("change");
              } 
              });
           }
         
        });
      
      
      $('.js-qty__adjust').on('click', numberAdjust);
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    initForm: initForm,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
